import { routes } from "../../routes/routes.constatns";
import { useDispatch } from "react-redux";
import { Button, Table } from "../../components";
import {
  inputCustomRenderer,
  customButtonRenderer,
  customTextRenderer,
} from "./InputCutomRenderer";
import "./ViewEngagement.scss";
import { useEffect, useState, useMemo } from "react";
import {
  GetAllEngagements,
  getEngagementDetailsByUser,
  updateEngagement,
  ImportSandboxEngagementObj
} from "../../store/services/engagement.service";
import EngagementLink from "./customEngagementLink";
import { useSelector } from "react-redux";
import { AddIcon, ArrowRightIcon } from "../../icons";
import {
  TableHeaderClientName,
  TableHeaderEngagementCode,
  TableHeaderEngagementName,
  TableHeaderEngagementStatus,
  CreateNewEngBtn,
  CreateDemoEngBtn,
  engDash,
  extUserDashboardM1Description,
  extUserDashboardM4Description,
  extUserDashboardM3Description,
  extUserDashboardM2Description,
  RegionNames,
  Manage,
  CurrentlyUnavailable,
  AccessDashboard,
  Analyse,
  Simulate,
  COMMON_ERROR_MESSAGE,
  sandboxEngAccessFlag
} from "../../util/constants";
import { ViewEngagementDeleteModal } from "./ViewEngagementDeleteModal";
import { DemoEngagementConfirmModal } from "../DemoEngagementModal/DemoEngagementConfirmModal";
import { DemoEngagementSuccessModal } from "../DemoEngagementModal/DemoEngagementSuccessModal";
import {
  MotifCard,
  MotifCardFooter,
  MotifCardBody,
  MotifCardHeader,
} from "../../assets/lib/motif";
import { SelectRegionModal } from "../SelectRegionModal/SelectRegionModal";
import { LoadingIndicatorEmbed } from "../CommonUIComponents/LoadingIndicator/LoadingIndicatorEmbed";
import { dropEngagementState } from "../../store/slices/engagementSlice";
import { useRegRedirectionAuthTokenAPAC } from "../../hooks/useAppRedirectionTokenAPAC";
import { useRegRedirectionAuthTokenUS } from "../../hooks/useAppRedirectionTokenUS";
import { useRegRedirectionAuthTokenEU } from "../../hooks/useAppRedirectionTokenEU";
import manageBackgroundImage from "../../assets/Images/BG_Image.png";
import { UsersConsent } from "../UsersConsent/UsersConsent";
import { getUserConsent } from "../../store/slices/engagementSlice";
import axios from "axios";
import { useEngagementPolling } from "../../hooks/useEngagementPolling";
import { MotifTooltip } from '../../assets/lib/motif';

export function ViewEngagement() {
  const [rowData, setRowData] = useState([]);
  const steps = useSelector((state) => state.stepper.steps);
  const regionList = useSelector((state) => state.engagement.regionList);
  const demoEngFlag = useSelector((state) => state.engagement?.sandboxEngUserFlag);
  const selectedRegionForDemoEngagement = useSelector((state) => state?.engagement?.selectedRegionForDemoEng);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSelectRegionVisible, setIsSelectRegionVisible] = useState(false);
  const [isSandboxEngagement, setIsSandboxEngagement] = useState(false);
  const [isDemoEngConfirmModalVisible, setIsDemoEngConfirmModalVisible] = useState(false);
  const [isDemoEngSuccessModalVisible, setIsDemoEngSuccessModalVisible] = useState(false);
  const [engagementToDelete, setEngagementToDelete] = useState("");
  const user = useSelector((state) => state.user.user);
  const [isDataLoadInProgress, setIsDataLoadInProgress] = useState(false);
  const [engagementData, setEngagementData] = useState([]);
  const [externalFlag, setExternalFlag] = useState(0);
  const token_APAC = useRegRedirectionAuthTokenAPAC();
  const token_US = useRegRedirectionAuthTokenUS();
  const token_EU = useRegRedirectionAuthTokenEU();
  const [powerBIFlags, setPowerBIFlags] = useState([]);
  const [sandboxErrorMessage, setSandboxErrorMessage] = useState("");
  const [demoEngLoader, setDemoEngLoader] = useState(false);
  const { startPolling, singleEngagementData } = useEngagementPolling();

  const dispatch = useDispatch();

  /* istanbul ignore next */
  function handleClick() {
    setIsSelectRegionVisible(true);
    dispatch(dropEngagementState());
  }

  function handleDemoEngClick() {
    setIsSandboxEngagement(true);
    handleClick();
  }

  async function fetchData() {
    setIsDataLoadInProgress(true);
    dropEngagementState();
    try {
      const request = {
        email: user.username,
        tokenAPAC: token_APAC,
        tokenUS: token_US,
        tokenEU: token_EU,
      };
      const data = await GetAllEngagements({ request });
      setEngagementData(data[0]);
      setExternalFlag(data[1]);
      const sortedEngagements = data[0]?.sort((a, b) => {
        // Put demo engagements (true) first
        return (b?.isSandboxEngagement === true) - (a?.isSandboxEngagement === true);
      });
      setRowData(sortedEngagements);

      // ✅ AUTO-START POLLING IF DEMO ENG EXISTS AND SETUP NOT COMPLETE
      const demoEng = data[0]?.find(
        (eng) =>
          eng?.isSandboxEngagement === true &&
          eng?.setupStepID !== 4 && eng?.sandboxEngagementStatus !== 'Failed'
      );

      console.log('demoEng', demoEng);

      if (demoEng?.id) {
        let token = token_EU; 
        if(demoEng?.regionID === 1) {
          console.log('Fetch getAll polling regionID 1')
          token = token_US;
        } else if(demoEng?.regionID === 2) {
          console.log('Fetch getAll polling regionID 2')
          token = token_APAC;
        } else if(demoEng?.regionID === 3) {
          console.log('Fetch getAll polling regionID 3')
          token = token_EU;
        }
        const apiUrl = regionList?.find(region => region?.id === demoEng?.regionID)?.apiUrl;
        startPolling(demoEng?.id, token, apiUrl);
      }

    } catch (error) {
      console.error(error);
    }
    setIsDataLoadInProgress(false);
  }

  async function createDemoEng() {
    try {
      console.log("Creating demo engagement in region:", selectedRegionForDemoEngagement);
      setDemoEngLoader(true);
      let token = token_EU; 
      const selectedRegionId = selectedRegionForDemoEngagement?.id ?? selectedRegionForDemoEngagement?.regionID;  
      if(selectedRegionId === 1) {
        console.log('regionID 1')
        token = token_US;
      } else if(selectedRegionId === 2) {
        console.log('regionID 2')
        token = token_APAC;
      } else if(selectedRegionId === 3) {
        console.log('regionID 3')
        token = token_EU;
      }
      let response = {};
      if (process.env.REACT_APP_MULTI_REGION_ALLOW === 'true') {
        response = await axios.post(
          `${selectedRegionForDemoEngagement?.apiUrl}WebApi/Invoke`,
          ImportSandboxEngagementObj,
          {
            withCredentials: true,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        const config = {
          withCredentials: true,
          sameSite: "Strict",
          "X-Frame-Options": "DENY",
          "Content-Security-Policy": "frame-ancestors 'none'",
        };

        response = await axios.post(
          `/WebApi/Invoke`,
          ImportSandboxEngagementObj,
          config
        );
      }  

      const res = response?.data;
      /**
       * Success Case → 200
       */
      if (res?.statusCode === 200) {
        setIsDemoEngConfirmModalVisible(false);
        setIsDemoEngSuccessModalVisible(true);
        fetchData();
        setDemoEngLoader(false);
        dispatch(getUserConsent({
          email: user.username,
          tokenAPAC: token_APAC,
          tokenUS: token_US,
          tokenEU: token_EU
        }));
        return res;
      }

      // Fallback for anything else (rare)
      setDemoEngLoader(false);
      setSandboxErrorMessage(COMMON_ERROR_MESSAGE);
      return res;
    } catch (error) {
      console.error("Caught Axios Error:", error);
      setDemoEngLoader(false);
      setSandboxErrorMessage(COMMON_ERROR_MESSAGE);
      return null;
    } finally {}
  }

  useEffect(() => {
    if (token_APAC && token_US && token_EU && regionList.length && steps.length) {
      console.log('Tokens are ready, fetching data');
      fetchData();
    }
  }, [token_APAC, token_US, token_EU, regionList.length, steps.length]);

  useEffect(() => {
    if (regionList.length && steps.length) {
      setIsDataLoadInProgress(true);
      dropEngagementState();
      getPowerBIFLags();
    }
    if (
      regionList.length &&
      steps.length &&
      process.env.REACT_APP_MULTI_REGION_ALLOW === `false`
    ) {
      fetchData();
    }
  }, [regionList.length, steps.length]);

  useEffect(() => {
    dropEngagementState();
  }, []);

  useEffect(() => {
    if (singleEngagementData?.id && singleEngagementData?.engagementSetupStepID === 4) {
      const item = rowData.find((item) => item.id === singleEngagementData?.id);
      item.setupStepID = singleEngagementData?.engagementSetupStepID;
      const engagementToDeleteIndex = rowData.findIndex(
        (item) => item.id === singleEngagementData?.id
      );

      rowData[engagementToDeleteIndex] = item;

      setRowData(
        rowData.sort((a, b) => {
          return b.activeFlag - a.activeFlag;
        })
      );
    }
  }, [singleEngagementData]);

  const getPowerBIFLags = async () => {
    const request = {
      user: user.username,
      tokenAPAC: token_APAC,
      tokenUS: token_US,
      tokenEU: token_EU,
    };
    const data = await getEngagementDetailsByUser({ request });
    setPowerBIFlags(data);
  };

  /* istanbul ignore next */
  function onDeleteEngagementClick(id) {
    setIsModalVisible(true);
    setEngagementToDelete(id);
  }

  /* istanbul ignore next */
  function onDeleteEngagementClose() {
    setIsModalVisible(false);
    setEngagementToDelete("");
  }

  function handelDemoEngConfirmCancel() {
    setIsDemoEngConfirmModalVisible(false);
    dispatch(dropEngagementState());
    setSandboxErrorMessage("");
  }

  function handelDemoEngSuccessModalCancel() {
    setIsDemoEngSuccessModalVisible(false);
    dispatch(dropEngagementState());
  }

  function handelDemoEngSuccessModalConfirm() {
    setIsDemoEngSuccessModalVisible(false);
    dispatch(dropEngagementState());
  }

  /* istanbul ignore next */
  async function onDeleteEngagementConfirm() {
    const item = rowData.find((item) => item.id === engagementToDelete);
    item.activeFlag = 0;
    item.updatedDate = new Date().toLocaleString();

    const request = {
      id: engagementToDelete,
      engagementName: item.engagementName,
      engagementCode: item.engagementCode,
      clientName: item.clientName,
      createdBy: item.createdBy,
      activeFlag: item.activeFlag,
      updatedDate: item.updatedDate,
      updatedBy: user.username
    };

    let token = token_EU; 
    if(item.regionID === 1) {
      console.log('regionID 1')
      token = token_US;
    } else if(item.regionID === 2) {
      console.log('regionID 2')
      token = token_APAC;
    } else if(item.regionID === 3) {
      console.log('regionID 3')
      token = token_EU;
    }
    var apiRegionUrl = regionList.find((x) => x.id === item.regionID).apiUrl;
    await updateEngagement({ request, url: apiRegionUrl, token });

    setIsModalVisible(false);
    setEngagementToDelete("");
    
    if (item?.isSandboxEngagement) {
      dispatch(getUserConsent({
        email: user.username,
        tokenAPAC: token_APAC,
        tokenUS: token_US,
        tokenEU: token_EU
      }));
    }

    const engagementToDeleteIndex = rowData.findIndex(
      (item) => item.id === engagementToDelete
    );
    rowData[engagementToDeleteIndex] = item;
    setRowData(
      rowData.sort((a, b) => {
        return a.activeFlag - b.activeFlag;
      })
    );
  }

  const renderCards = () => {
    const engagementIds = new Set(
      powerBIFlags.map(item => item.engagementId)
    );
    const filteredEngagements = engagementData.filter(
      engagement => engagementIds.has(engagement.id)
    );
    return filteredEngagements?.map((element) => {
      // let data = powerBIFlags.filter(
      //   (flag) => flag.engagementId === element.id
      // );
      let region_URL = "";
      if (element.regionName === RegionNames.UNITED_STATES) {
        region_URL = process.env.REACT_APP_URL_REG_US;
      } else if (element.regionName === RegionNames.SINGAPORE) {
        region_URL = process.env.REACT_APP_URL_REG_APAC;
      } else if (element.regionName === RegionNames.NETHERLANDS) {
        region_URL = process.env.REACT_APP_URL_REG_EU;
      } else {
        region_URL = process.env.REACT_APP_URL_REG_ALL;
      }
      return (
        <div className="motif-card-head">
          <div className="dashboard-engagement-name">
            <span>Client name: {element.clientName}</span>
          </div>

          <div className="dashboard-engagement-name">
            <span>
              {"Engagement name : "}
              {element.engagementName}
            </span>
          </div>
          <div className="dashboard-cards">
            <MotifCard
              className={`dashboards-card-home ${
                element?.m1_toggle_enable === "N"
                  ? "dashboards-card-home-disabled"
                  : ""
              }`}
              style={{
                backgroundImage: `url(${manageBackgroundImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                height: "auto",
              }}
            >
              <MotifCardHeader className="dashboards-card-home-header">
                <span>{Manage}</span>
              </MotifCardHeader>
              <div className="dashboard-cards-description-body">
                <MotifCardBody>
                  <span className="dashboard-cards-description-body-label">
                    {extUserDashboardM1Description}
                  </span>
                  <div className="dashboard-card-image-container">
                    <img
                      src={require("../../assets/Images/M1New.png")}
                      alt="Emission Data"
                      loading="lazy"
                    />
                    {element?.m1_toggle_enable === "N" && (
                      <div className="dashboard-card-not-available">
                        {CurrentlyUnavailable}
                      </div>
                    )}
                  </div>
                </MotifCardBody>
              </div>
              <MotifCardFooter>
                <button
                  className="transparent-button"
                  onClick={() => {
                    window.location.href = `${region_URL}${routes.externalUserPowerBI}?engagementCode=${element.engagementCode}&module=M1`;
                  }}
                >
                  {"Access dashboard "}
                  <span>
                    <ArrowRightIcon />
                  </span>
                </button>
              </MotifCardFooter>
            </MotifCard>
            <MotifCard
              className={`dashboards-card-home ${
                element?.m2_toggle_enable === "N"
                  ? "dashboards-card-home-disabled"
                  : ""
              }`}
              style={{
                backgroundImage: `url(${manageBackgroundImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                height: "auto",
              }}
            >
              <MotifCardHeader className="dashboards-card-home-header">
                <span>Forecast</span>
              </MotifCardHeader>
              <div className="dashboard-cards-description-body">
                <MotifCardBody>
                  <span className="dashboard-cards-description-body-label">
                    {extUserDashboardM2Description}
                  </span>
                  <div className="dashboard-card-image-container">
                    <img
                      src={require("../../assets/Images/M2New.png")}
                      alt="Emission Data"
                      loading="lazy"
                    />
                    {element?.m2_toggle_enable === "N" && (
                      <div className="dashboard-card-not-available">
                        {CurrentlyUnavailable}
                      </div>
                    )}
                  </div>
                </MotifCardBody>
              </div>
              <MotifCardFooter>
                <button
                  className="transparent-button"
                  onClick={() => {
                    window.location.href = `${region_URL}${routes.externalUserPowerBI}?engagementCode=${element.engagementCode}&module=M2`;
                  }}
                >
                  {AccessDashboard}
                  <span>
                    <ArrowRightIcon />
                  </span>
                </button>
              </MotifCardFooter>
            </MotifCard>
            <MotifCard
              className={`dashboards-card-home ${
                element?.m3_toggle_enable === "N"
                  ? "dashboards-card-home-disabled"
                  : ""
              }`}
              style={{
                backgroundImage: `url(${manageBackgroundImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                height: "auto",
              }}
            >
              <MotifCardHeader className="dashboards-card-home-header">
                <span>{Analyse}</span>
              </MotifCardHeader>
              <div className="dashboard-cards-description-body">
                <MotifCardBody>
                  <span className="dashboard-cards-description-body-label">
                    {extUserDashboardM3Description}
                  </span>
                  <div className="dashboard-card-image-container">
                    <img
                      src={require("../../assets/Images/M3New.png")}
                      alt="Emission Data"
                      loading="lazy"
                    />
                    {element?.m3_toggle_enable === "N" && (
                      <div className="dashboard-card-not-available">
                        {CurrentlyUnavailable}
                      </div>
                    )}
                  </div>
                </MotifCardBody>
              </div>
              <MotifCardFooter>
                <button
                  className="transparent-button"
                  onClick={() => {
                    window.location.href = `${region_URL}${routes.externalUserPowerBI}?engagementCode=${element.engagementCode}&module=M3`;
                  }}
                >
                  {"Access dashboard "}
                  <span>
                    <ArrowRightIcon />
                  </span>
                </button>
              </MotifCardFooter>
            </MotifCard>
            <MotifCard
              className={`dashboards-card-home ${
                element?.m4_toggle_enable === "N"
                  ? "dashboards-card-home-disabled"
                  : ""
              }`}
              style={{
                backgroundImage: `url(${manageBackgroundImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                height: "auto",
              }}
            >
              <MotifCardHeader className="dashboards-card-home-header">
                <span>{Simulate}</span>
              </MotifCardHeader>
              <div className="dashboard-cards-description-body">
                <MotifCardBody>
                  <span className="dashboard-cards-description-body-label">
                    {extUserDashboardM4Description}
                  </span>
                  <div className="dashboard-card-image-container">
                    <img
                      src={require("../../assets/Images/M4New.png")}
                      alt="Emission Data"
                      loading="lazy"
                    />
                    {element?.m4_toggle_enable === "N" && (
                      <div className="dashboard-card-not-available">
                        {CurrentlyUnavailable}
                      </div>
                    )}
                  </div>
                </MotifCardBody>
              </div>
              <MotifCardFooter>
                <button
                  className="transparent-button"
                  onClick={() => {
                    window.location.href = `${region_URL}${routes.externalUserPowerBI}?engagementCode=${element.engagementCode}&module=M4`;
                  }}
                >
                  {AccessDashboard}
                  <span>
                    <ArrowRightIcon />
                  </span>
                </button>
              </MotifCardFooter>
            </MotifCard>
          </div>
        </div>
      );
    });
  };
  
  const colDefs = useMemo(() => 
    [
      {
        field: "engagementName",
        cellRenderer: EngagementLink,
        headerName: TableHeaderEngagementName,
        headerTooltip: TableHeaderEngagementName,
        sortable: true,
        flex: 0.6,
        suppressMovable: true,
        pinned: "left",
        minWidth: 250,
      },
      {
        field: "engagementCode",
        headerName: TableHeaderEngagementCode,
        headerTooltip: TableHeaderEngagementCode,
        flex: 0.5,
        minWidth: 200,
        cellRenderer: customTextRenderer,
        suppressMovable: true,
      },
      {
        field: "clientName",
        headerName: TableHeaderClientName,
        headerTooltip: TableHeaderClientName,
        flex: 0.4,
        minWidth: 200,
        cellRenderer: customTextRenderer,
        suppressMovable: true,
      },
      {
        field: "regionName",
        headerName: "Hosting location",
        headerTooltip: "Hosting location",
        flex: 0.4,
        minWidth: 150,
        suppressMovable: true,
      },
      {
        field: "engagementStatus",
        cellRenderer: inputCustomRenderer,
        cellRendererParams: () => {
          return {
            steps: steps,
          };
        },
        headerComponentParams: {
          enableSorting: false,
          showFilter: false,
        },
        headerName: TableHeaderEngagementStatus,
        headerTooltip: TableHeaderEngagementStatus,
        flex: 1.5,
        minWidth: 600,
        suppressMovable: true,
      },
      {
        cellRenderer: customButtonRenderer,
        cellRendererParams: () => {
          return {
            onDeleteEngagementClick: onDeleteEngagementClick,
          };
        },
        field: "actions",
        headerName: "",
        width: 80,
      },
    ], [steps, onDeleteEngagementClick]);

  return (
    <div className="view-engagement">
      <div className="view-engagement-header">
        <div className="view-engagement-header-h">
          <span className="view-engagement-header-title">{engDash}</span>
        </div>
        {externalFlag === 0 && (
          <div className="create-new-demo-engagement-group">
            {(demoEngFlag !== sandboxEngAccessFlag.NO_ACCESS 
              && demoEngFlag === sandboxEngAccessFlag.HAS_EXISTING_SANDBOX_ENG) ? (
                  <MotifTooltip
                    children={<>Only one sandbox engagement can be created at a time. To create a new one, please delete the existing one</>}
                    placement="bottom"
                    hideCloseButton="true"
                    variant="alt"
                    usePortal={false}
                    offset={[0, 8]}
                    trigger={
                      <Button
                        className="view-engagement-header-demo-project"
                        variant={
                          demoEngFlag === sandboxEngAccessFlag.HAS_EXISTING_SANDBOX_ENG 
                          ? "primary" : "secondary"
                        }
                        onClick={handleDemoEngClick}
                        disabled={demoEngFlag === sandboxEngAccessFlag.HAS_EXISTING_SANDBOX_ENG}
                      >
                        {CreateDemoEngBtn}
                      </Button>
                    }
                />) : demoEngFlag !== sandboxEngAccessFlag.NO_ACCESS &&
                  demoEngFlag === sandboxEngAccessFlag.HAS_ACCESS &&(
                  <Button
                    className="view-engagement-header-demo-project"
                    variant={"secondary"}
                    onClick={handleDemoEngClick}
                  >
                    {CreateDemoEngBtn}
                  </Button>
                )
              }
            <Button
              onClick={handleClick}
              className={"view-engagement-header-new-project"}
              variant="primary-alt"
            >
              <AddIcon />
              {CreateNewEngBtn}
            </Button>
          </div>
        )}
      </div>
      <LoadingIndicatorEmbed show={isDataLoadInProgress}>
        <div className="view-engagement-table">
          <div style={{ display: externalFlag === 0 ? "block" : "none" }}>
            <Table
              suppressAnimationFrame={true}
              deltaRowDataMode={true}
              immutableData={true}
              getRowId={(params) => params.data.id}
              suppressColumnVirtualisation={true}
              colDefs={colDefs}
              rowData={rowData}
              rowClassRules={{
                "view-engagement-closed-project": (params) => {
                  return params.data.activeFlag === 0;
                },
                "view-engagement-demo-project-in-progress" : (params) => {
                  return params?.data?.isSandboxEngagement && params?.data?.setupStepID !== 4;
                }
              }}
              draggable={false}
              loading={isDataLoadInProgress}
            />
          </div>

          {externalFlag === 1 && (
            <div className="engagement-dashboard-fullscreen">
              {renderCards()}
            </div>
          )}
        </div>
      </LoadingIndicatorEmbed>
      <ViewEngagementDeleteModal
        isModalVisible={isModalVisible}
        onClose={onDeleteEngagementClose}
        onConfirm={onDeleteEngagementConfirm}
      />
      <SelectRegionModal
        isModalVisible={isSelectRegionVisible}
        onSubmit={() => {
          if (isSandboxEngagement) {
            setIsDemoEngConfirmModalVisible(true);
          }
        }}
        onClose={() => {
          setIsSelectRegionVisible(false); 
          setIsSandboxEngagement(false);
        }}
        isSandboxEngagement={isSandboxEngagement}
      />
      <DemoEngagementConfirmModal
        isModalVisible={isDemoEngConfirmModalVisible}
        onClose={handelDemoEngConfirmCancel}
        onConfirm={() => {
          createDemoEng();
        }}
        errorMessage={sandboxErrorMessage}
        demoEngLoader={demoEngLoader}
      />
      <DemoEngagementSuccessModal
        isModalVisible={isDemoEngSuccessModalVisible}
        onClose={handelDemoEngSuccessModalCancel}
        onConfirm={handelDemoEngSuccessModalConfirm}
      />
      <UsersConsent />
    </div>
  );
}
